var _rect, _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _g5, _path0, _path1, _g6, _path10, _path11, _g7, _path12, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordLogoError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9373_27792)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 98,
    width: 98,
    height: 98,
    rx: 49,
    transform: "rotate(-90 0 98)",
    fill: "url(#paint0_linear_9373_27792)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9287 43.4914C28.9287 43.4914 45.1852 42.3831 45.2959 59.7748C27.8168 59.6645 28.9287 43.4914 28.9287 43.4914Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9373_27792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 42,
    width: 20,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9241 42.0902H46.6006V60.8711H27.9241V42.0902Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9373_27792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2454 60.7282L45.2894 60.7232C39.6517 60.6856 35.2668 59.0332 32.2555 55.8036C27.5411 50.751 27.9663 43.7302 27.9864 43.4343L28.0418 42.6194L28.8644 42.5617C28.8644 42.5617 29.0958 42.5441 29.5034 42.5441C32.2807 42.5441 46.1347 43.3766 46.2403 59.7754L46.2454 60.7282Z",
    fill: "url(#paint1_linear_9373_27792)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9373_27792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 25,
    width: 14,
    height: 27
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4478 25H54.9721V51.0751H41.4478V25Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9373_27792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2892 50.7457L47.6176 50.0687C43.6553 46.0768 41.7308 41.8217 41.8969 37.4211C42.156 30.5306 47.444 25.8667 47.6704 25.6736L48.2892 25.1345L48.9106 25.6736C49.137 25.8667 54.425 30.5306 54.6842 37.4211C54.8502 41.8217 52.9257 46.0768 48.9635 50.0687L48.2892 50.7457Z",
    fill: "url(#paint2_linear_9373_27792)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1113 43.4914C68.1113 43.4914 51.8573 42.3831 51.7441 59.7748C69.2257 59.6645 68.1113 43.4914 68.1113 43.4914Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9373_27792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 42,
    width: 20,
    height: 19
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4641 42.0902H69.1407V60.8711H50.4641V42.0902Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9373_27792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7937 60.7282L50.8012 59.7754C50.9069 43.3766 64.7609 42.5441 67.5357 42.5441C67.9457 42.5441 68.1772 42.5617 68.1772 42.5617L68.9973 42.6194L69.0552 43.4343C69.0753 43.7302 69.5004 50.7485 64.786 55.8036C61.7772 59.0332 57.3899 60.6856 51.7497 60.7232L50.7937 60.7282Z",
    fill: "url(#paint3_linear_9373_27792)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9373_27792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 52,
    width: 45,
    height: 52
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6313 52.7663H70.4246V103.001H26.6313V52.7663Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9373_27792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9373_27792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 52,
    width: 45,
    height: 52
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3853 103.004V52.81C56.2369 52.7999 56.091 52.7999 55.9426 52.7999H41.1301V103.004H56.3853ZM37.3339 103.004H41.1301V52.81H41.0471C34.9088 52.81 29.5202 57.8023 29.0774 63.8979L27.002 91.9288C26.5466 98.0119 31.1982 103.004 37.3339 103.004ZM59.6532 103.004C65.7915 103.004 70.4405 98.0119 69.9877 91.9163L67.9097 63.8879C67.467 57.9402 62.3224 53.0432 56.3753 52.81V103.004H59.6532Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9373_27792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.0192 103.005H27.0007V52.7704H70.0192V103.005Z",
    fill: "#FFDE59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4758 78.4135L40.6749 90.1409C40.2098 93.1692 42.5531 95.8998 45.617 95.8998H48.4099H51.3486C54.3619 95.8998 56.6906 93.2541 56.3081 90.2651L54.8074 78.5378C54.488 76.0421 52.3639 74.1724 49.8478 74.1724H47.4178C44.9495 74.1724 42.8504 75.9737 42.4758 78.4135Z",
    fill: "#353535"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_9373_27792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 51,
    width: 20,
    height: 21
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26 51.4969H45.6074V71.04H26V51.4969Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_9373_27792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_9373_27792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 51,
    width: 20,
    height: 21
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8037 51.5013C30.3899 51.5013 26 55.8743 26 61.2728C26 66.6689 30.3899 71.0444 35.8037 71.0444C41.2175 71.0444 45.6074 66.6689 45.6074 61.2728C45.6074 55.8743 41.2175 51.5013 35.8037 51.5013Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_9373_27792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 51.5013H45.6074V71.0444H26V51.5013Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_9373_27792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 57,
    width: 13,
    height: 13
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7461 57.0192H43.9724V69.208H31.7461V57.0192Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_9373_27792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_9373_27792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 57,
    width: 13,
    height: 13
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8612 57.0192C34.4851 57.0192 31.748 59.7473 31.748 63.1149C31.748 66.4799 34.4851 69.208 37.8612 69.208C41.2373 69.208 43.9743 66.4799 43.9743 63.1149C43.9743 59.7473 41.2373 57.0192 37.8612 57.0192Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_9373_27792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.748 57.0192H43.9743V69.208H31.748V57.0192Z",
    fill: "#3D1F1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.6415,
    cy: 66.1676,
    rx: 2.29849,
    ry: 2.28709,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_9373_27792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 51,
    width: 21,
    height: 21
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3933 51.4969H71.0007V71.04H51.3933V51.4969Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_9373_27792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_9373_27792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 51,
    width: 21,
    height: 21
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1992 51.5013C55.7829 51.5013 51.3955 55.8744 51.3955 61.2729C51.3955 66.669 55.7829 71.0445 61.1992 71.0445C66.613 71.0445 71.0029 66.669 71.0029 61.2729C71.0029 55.8744 66.613 51.5013 61.1992 51.5013Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_9373_27792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.3955 51.5013H71.0029V71.0445H51.3955V51.5013Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_9373_27792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 57,
    width: 13,
    height: 13
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6975 57.0192C56.3189 57.0192 53.5818 59.7473 53.5818 63.1149C53.5818 66.4799 56.3189 69.208 59.6975 69.208C63.0735 69.208 65.8106 66.4799 65.8106 63.1149C65.8106 59.7473 63.0735 57.0192 59.6975 57.0192Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_9373_27792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5818 57.0192H65.8106V69.208H53.5818V57.0192Z",
    fill: "#3D1F1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.328,
    cy: 66.1676,
    rx: 2.29849,
    ry: 2.28709,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9373_27792",
    x1: 0.00000171925,
    y1: 184.555,
    x2: 98,
    y2: 98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00221239,
    stopColor: "#FF4E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9373_27792",
    x1: 37.1068,
    y1: 42.5441,
    x2: 37.1068,
    y2: 60.7282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9373_27792",
    x1: 48.2905,
    y1: 25.1345,
    x2: 48.2905,
    y2: 50.7457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9373_27792",
    x1: 59.9335,
    y1: 42.5441,
    x2: 59.9335,
    y2: 60.7282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9373_27792"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 98,
    width: 98,
    height: 98,
    rx: 49,
    transform: "rotate(-90 0 98)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordLogoError);
export default __webpack_public_path__ + "static/media/passwordLogoError.fe7589f9c681d6efda99da37b8aa7599.svg";
export { ForwardRef as ReactComponent };